import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import { getGiraUrl } from '@atlassian/jira-issue-fetch-services-common/src/services/issue-gira-data/index.tsx';

export type GiraQuery<_R> = string;

const makeFetchClient = () => ({
	query: <T,>({
		query,
		variables,
		signal,
		operationName,
	}: {
		query: GiraQuery<T>;
		variables: unknown;
		signal?: AbortSignal;
		operationName?: string;
	}): Promise<T> =>
		fetchJson(getGiraUrl(operationName), {
			method: 'POST',
			body: JSON.stringify({
				query,
				variables,
				operationName,
			}),
			signal,
		}),
});

let client: ReturnType<typeof makeFetchClient>;
export const getClient = () => {
	if (!client) {
		client = makeFetchClient();
	}

	return client;
};
